<template>
  <Row>
    <Divider style="height: 10px; margin: 0" />
    <Col span="4">
      <Tree :data="databaseTree" @on-select-change="expandTree"></Tree>
    </Col>
    <Col span="20">
      <Tabs type="card" closable @on-tab-remove="handleTabRemove" :animated="false" size="small" v-model="aceTab">
        <Button @click="handleTabsAdd" size="small" slot="extra">增加</Button>

        <TabPane v-for="tab in tabList" v-if="tab" :key="tab" :label="'SQL窗口'+tab">
          <div class="ace-container">
            <Form inline ref="opsForm" :label-width="5" onsubmit="return false;" style="height: 45px; margin-top: 10px; margin-left: 5px">
              <FormItem>
                <Select v-model="db" style="width:155px" clearable filterable>
                  <Option v-for="db in databaseList"
                          :key="db"
                          :label="db"
                          :value="db">
                  </Option>
                </Select>
              </FormItem>
              <FormItem>
                <Button icon="md-color-wand" type="info" @click="format">格式美化</Button>
              </FormItem>
              <FormItem>
                <Button icon="md-eye" type="primary" @click="explain">查看执行计划</Button>
              </FormItem>
              <FormItem>
                <Select v-model="returnRow" style="width:80px">
                  <Option disabled label="返回行数" value="0"></Option>
                  <Option label="100" value='100'></Option>
                  <Option label="500" value='500'></Option>
                  <Option label="1000" value='1000'></Option>
                </Select>
              </FormItem>
              <FormItem>
                <Button icon="md-play" type="success" @click="execute">执行SQL</Button>
              </FormItem>
              <FormItem>
                <Button icon="md-undo" @click="undo" :disabled=hasUndo>撤销</Button>
              </FormItem>
              <FormItem>
                <Button icon="md-redo" @click="redo" :disabled=hasRedo>重做</Button>
              </FormItem>
              <FormItem>
                <Poptip
                  confirm
                  title="请确认是否导出?"
                  @on-ok="exportData"
                  ok-text="确认"
                  cancel-text="取消"
                  placement="bottom">
                  <Button icon="md-download" type="warning">导出结果</Button>
                </Poptip>
              </FormItem>
            </Form>
            <div class="ace-editor" v-bind:id="'ace'+ tab"></div>
            <div class="config-panel" v-show="toggle">
              <div>
                <div class="item">
                  <label class="title">语言</label>
                  <Select class="value" v-model="modePath" @on-change="handleModelPathChange" size="small">
                    <Option v-for="mode in modeArray"
                            :key="mode.name"
                            :label="mode.name"
                            :value="mode.path">
                    </Option>
                  </Select>
                </div>

                <div class="item">
                  <label class="title">主题</label>
                  <Select class="value" v-model="themePath" @on-change="handleThemePathChange" size="small">
                    <Option v-for="theme in themeArray"
                            :key="theme.name"
                            :label="theme.name"
                            :value="theme.path">
                    </Option>
                  </Select>
                </div>

                <div class="item">
                  <label class="title">自动换行</label>
                  <Select class="value" v-model="wrap" @on-change="handleWrapChange" size="small">
                    <Option v-for="wrap in wrapArray"
                            :key="wrap.name"
                            :label="wrap.name"
                            :value="wrap.value">
                    </Option>
                  </Select>
                </div>
              </div>
            </div>
            <div class="bookmarklet" @click="toggleConfigPanel"></div>
          </div>
        </TabPane>
        <div>
          <Divider style="height: 10px; margin: 0" />
          <!--<DatePicker v-show="datePicker" type="daterange" :value="dateValue" :options="dateOption" placeholder="Select date"-->
          <!--placement="bottom-end" @on-change="getExecuteLog"></DatePicker>-->
          <Tabs type="card" v-model="sqlTab" @on-click="refreshExecuteLog">
            <TabPane label="执行记录">
              <Table ref="executeLogTable" height="300" :data="executeLogData" :columns="executeLogColumns" size="small"/>
              <Row style="margin: 10px;">
                <div style="float: right;">
                  <page :total="count" :current="page" :page-size="size" @on-change="getExecuteLog"></page>
                </div>
              </Row>
            </TabPane>
            <TabPane v-for="tab in tabData" :key="tab.id" :label="'结果' + tab.id">
              <Row>
                <Col>
                  <Icon type="md-information-circle" size="20"/>
                </Col>
              </Row>
              <Row>
                <Table ref="resTable" height="300" :data="tab.res" :columns="tab.columns" />
              </Row>
            </TabPane>
          </Tabs>
        </div>
      </Tabs>
    </Col>
  </Row>
</template>

<script>
import {showDatabaseList, explainSQL, executeSQL, getExecuteLog} from '@/api/mysql'
import sqlFormatter from 'sql-formatter'
import ace from 'ace-builds'
import 'ace-builds/src-noconflict/snippets/sql'
import 'ace-builds/src-noconflict/snippets/javascript'
import 'ace-builds/src-noconflict/snippets/html'
import 'ace-builds/src-noconflict/snippets/css'
import 'ace-builds/src-noconflict/snippets/scss'
import 'ace-builds/src-noconflict/snippets/json'
import 'ace-builds/src-noconflict/snippets/java'
import 'ace-builds/src-noconflict/snippets/text'
import 'ace-builds/webpack-resolver'
import 'ace-builds/src-noconflict/ext-language_tools'
import 'ace-builds/src-noconflict/theme-monokai'
import 'ace-builds/src-noconflict/theme-sqlserver'
import 'ace-builds/src-noconflict/theme-xcode'
import 'ace-builds/src-noconflict/theme-tomorrow'
import 'ace-builds/src-noconflict/theme-eclipse'
import 'ace-builds/src-noconflict/theme-terminal'
import 'ace-builds/src-noconflict/mode-sql'

const wrapArray = [{
  name: '开启',
  value: 1
}, {
  name: '关闭',
  value: 0
}]

const themeArray = [{
  name: 'sqlserver',
  path: 'ace/theme/sqlserver'
}, {
  name: 'monokai',
  path: 'ace/theme/monokai'
}, {
  name: 'terminal',
  path: 'ace/theme/terminal'
}, {
  name: 'eclipse',
  path: 'ace/theme/eclipse'
}, {
  name: 'tomorrow',
  path: 'ace/theme/tomorrow'
}, {
  name: 'xcode',
  path: 'ace/theme/xcode'
}]

const modeArray = [{
  name: 'SQL',
  path: 'ace/mode/sql'
}, {
  name: 'JavaScript',
  path: 'ace/mode/javascript'
}, {
  name: 'HTML',
  path: 'ace/mode/html'
}, {
  name: 'CSS',
  path: 'ace/mode/css'
}, {
  name: 'SCSS',
  path: 'ace/mode/scss'
}, {
  name: 'Json',
  path: 'ace/mode/json'
}, {
  name: 'Java',
  path: 'ace/mode/java'
}, {
  name: 'Text',
  path: 'ace/mode/text'
}]

export default {
  mounted () {
    this.getDatabases()
    this.addAceEditor(1)
    this.addAceEditor(2)
    this.getExecuteLog()
  },
  data () {
    return {
      tabs: 2,
      aceTab: 0,
      tabList: [0, 1, 2],
      sqlTab: 0,
      page: 1,
      count: 0,
      size: 15,
      datePicker: true,
      dateValue: [new Date(new Date().setDate(new Date().getDate() - 29)).toISOString().slice(0, 10), new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().slice(0, 10)],
      dateOption: {
        shortcuts: [
          {
            text: '今天',
            value () {
              const start = new Date()
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              return [start, end]
            }
          },
          {
            text: '三天',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
              return [start, end]
            }
          },
          {
            text: '一周',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
              return [start, end]
            }
          },
          {
            text: '一个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
              return [start, end]
            }
          },
          {
            text: '三个月',
            value () {
              const end = new Date(new Date().setDate(new Date().getDate() + 1))
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
              return [start, end]
            }
          }
        ]
      },
      aceEditor: [0],
      toggle: false,
      wrap: 1,
      themePath: 'ace/theme/sqlserver',
      modePath: 'ace/mode/sql',
      modeArray: modeArray,
      wrapArray: wrapArray,
      themeArray: themeArray,
      returnRow: '100',
      hasRedo: true,
      hasUndo: true,
      databaseList: [],
      databaseTree: [],
      db: '',
      tabData: [],
      executeLogData: [],
      executeLogColumns: [
        {
          title: '时间',
          key: 'create_time',
          align: 'center',
          width: 165,
          render: (h, params) => {
            return h('div', new Date(params.row.create_time).toLocaleString())
          }
        },
        {title: 'SQL', key: 'sql', tooltip: true},
        {title: '执行结果',
          key: 'is_failed',
          width: 150,
          render: (h, params) => {
            return h('div', params.row.is_failed ? '执行失败' : '执行成功')
          }
        }
      ]
    }
  },
  watch: {
    'tabList': function () {
      this.$nextTick(function () {
        this.addAceEditor(this.tabs)
      })
    }
  },
  methods: {
    addAceEditor (id) {
      let aceName = 'ace' + id
      this.aceEditor[id] = ace.edit(aceName, {
        maxLines: 30,
        minLines: 20,
        fontSize: 14,
        value: '',
        theme: 'ace/theme/sqlserver',
        mode: 'ace/mode/sql',
        wrap: 1,
        tabSize: 4
      })
      // 激活自动提示
      this.aceEditor[id].setOptions({
        enableSnippets: true,
        enableLiveAutocompletion: true,
        enableBasicAutocompletion: true,
        printMargin: false,
        printMarginColumn: 120
      })
      this.aceEditor[id].getSession().on('change', this.change)
    },
    handleTabRemove (name) {
      let tmpTab = this.tabList
      this.tabList = []
      this.tabList = tmpTab
      this.tabList[name + 1] = 0
    },
    handleTabsAdd () {
      this.tabs++

      let tmpTab = this.tabList
      this.tabList = []
      this.tabList = tmpTab
      this.tabList[this.tabs] = this.tabs

      // console.log(this.tabs)
      // this.addAceEditor(this.tabs)
      // console.log(this.aceEditor)
    },
    expandTree (group, name) {
      name.expand = !name.expand
    },
    toggleConfigPanel () {
      this.toggle = !this.toggle
    },
    change () {
      this.$emit('input', this.aceEditor[this.aceTab + 1].getSession().getValue())
      let um = this.aceEditor[this.aceTab + 1].getSession().getUndoManager()
      this.hasUndo = !um.hasUndo()
      this.hasRedo = !um.hasRedo()
    },
    redo (session, dontSelect) {
      let um = this.aceEditor[this.aceTab + 1].getSession().getUndoManager()
      um.redo(this.aceEditor[this.aceTab + 1].getSession())
    },
    undo () {
      let um = this.aceEditor[this.aceTab + 1].getSession().getUndoManager()
      um.undo(this.aceEditor[this.aceTab + 1].getSession())
    },
    handleModelPathChange (modelPath) {
      this.aceEditor[this.aceTab + 1].getSession().setMode(modelPath)
    },
    handleThemePathChange (themePath) {
      this.aceEditor[this.aceTab + 1].setTheme(themePath)
    },
    handleWrapChange (wrap) {
      this.aceEditor[this.aceTab + 1].getSession().setUseWrapMode(wrap === 1)
    },

    format () {
      this.aceEditor[this.aceTab + 1].setValue(sqlFormatter.format(this.aceEditor[this.aceTab + 1].getSession().getValue()))
    },

    getDatabases () {
      let params = {
        id: this.$route.query.id
      }
      this.databaseList = []
      showDatabaseList(params).then(res => {
        if (res.status === 200) {
          this.databaseList = res.data.results
          this.databaseTree.push({title: this.$route.query.name, expand: true, children: []})
          for (let i in res.data.results) {
            this.databaseTree[0]['children'].push({
              title: res.data.results[i],
              expand: false,
              children: [
                {
                  title: '表',
                  expand: false,
                  children: []
                },
                {
                  title: '视图',
                  expand: false,
                  children: []
                },
                {
                  title: '函数',
                  expand: false,
                  children: []
                },
                {
                  title: '事件',
                  expand: false,
                  children: []
                }
              ]
            })
          }
        }
      })
    },

    explain () {
      let data = {
        id: this.$route.query.id,
        db: this.db,
        sql: this.aceEditor[this.aceTab + 1].getSelectedText() ? this.aceEditor[this.aceTab + 1].getSelectedText() : this.aceEditor[this.aceTab + 1].getSession().getValue()
      }
      let that = this
      explainSQL(data).then(res => {
        that.tabData = []
        res.data.results.forEach(function (item, index) {
          that.tabData.push({'id': index + 1, 'res': item, 'columns': []})
          let cols = Object.keys(item[0])
          if (cols) {
            cols.forEach(function (row) {
              that.tabData[index].columns.push({'title': row, 'key': row, 'minWidth': 130})
            })
          }
        })
        that.sqlTab = 1
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },

    execute () {
      let data = {
        id: this.$route.query.id,
        db: this.db,
        sql: this.aceEditor[this.aceTab + 1].getSelectedText() ? this.aceEditor[this.aceTab + 1].getSelectedText() : this.aceEditor[this.aceTab + 1].getSession().getValue(),
        limit: this.returnRow
      }
      let that = this
      executeSQL(data).then(res => {
        that.tabData = []
        res.data.results.forEach(function (item, index) {
          that.tabData.push({'id': index + 1, 'res': item, 'columns': []})
          let cols = Object.keys(item[0])
          if (cols) {
            cols.forEach(function (row) {
              that.tabData[index].columns.push({'title': row, 'key': row, 'minWidth': 130})
            })
          }
        })
        that.sqlTab = 1
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + res.request.status
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },

    getExecuteLog (value = 1) {
      if (typeof value === 'number') {
        this.page = value
      } else {
        let end = new Date(value[1])
        end.setTime(end.getTime() + 3600 * 1000 * 24)
        this.dateValue[0] = value[0]
        this.dateValue[1] = end.toISOString().slice(0, 10)
      }
      let params = {
        instance_id: this.$route.query.id,
        page: this.page,
        size: this.size,
        execute_user_id: this.$store.state.user.userId,
        create_time__gt: this.dateValue[0],
        create_time__lt: this.dateValue[1]
      }
      getExecuteLog(params).then(res => {
        this.executeLogData = res.data.results
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取进程列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取进程列表失败！服务器无响应'
          })
        }
      })
    },

    refreshExecuteLog: function (name) {
      this.sqlTab = name
      if (!name) {
        this.datePicker = true
        this.getExecuteLog()
      } else {
        this.datePicker = false
      }
    },

    exportData () {
      if (this.datePicker) {
        this.$refs.executeLogTable.exportCsv({
          filename: `executeLog-${(new Date()).valueOf()}.csv`
        })
      } else {
        this.$refs.resTable[this.sqlTab - 1].exportCsv({
          filename: `query-${(new Date()).valueOf()}.csv`
        })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
  .ace-container {
    position: relative;
    .config-panel {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 30%;
      height: 100%;
      overflow: scroll;
      box-shadow: grey -5px 2px 3px;
      background-color: rgba(255, 255, 255, 0.5);
      z-index: 1;

      .item {
        margin: 10px auto;
        text-align: center;

        .title {
          color: black;
          margin: 0 10px;
          font-size: 14px;
        }
      }
    }

    .bookmarklet {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 15px;
      height: 15px;
      z-index: 2;
      cursor: pointer;
      border-width: 7px;
      border-style: solid;
      border-color: lightblue gray gray rgb(206, 173, 230);
      border-image: initial;
    }

  }
</style>
